<template>
  <div>
    <v-order-detail orderPayType="auction"></v-order-detail>
  </div>
</template>

<script>
import OrderDetail from '@/components/OrderDetail';
export default {
  name: 'auctionDetailOrder',
  components: {
    'v-order-detail': OrderDetail
  }
};
</script>